import { Users, XCircle } from "lucide-react";
import { Section, money } from "../dc";
import { REPS, LOST_REASONS, C, FUNNEL } from "./data";

export const RepTable = () => (
  <Section title="Follow-up productivity" sub="Per rep in the selected period. First reply = median time from lead in to first action; turnaround = median time between follow-ups." icon={Users} testid="lx-reps">
    <div style={{ overflowX: "auto" }}>
      <table className="table" style={{ width: "100%" }}>
        <thead><tr>{["Rep", "Leads", "Actions", "First reply", "Turnaround", "Won", "Win %", "Revenue (90d)"].map((h) => <th key={h} style={{ textAlign: "left" }}>{h}</th>)}</tr></thead>
        <tbody>
          {REPS.map((r, i) => (
            <tr key={r.name} style={{ background: i % 2 ? "#F5F9F9" : undefined }} data-testid={`lx-rep-${i}`}>
              <td style={{ fontWeight: 700, whiteSpace: "nowrap" }}>{r.name}</td>
              <td className="mono">{r.leads}</td>
              <td className="mono">{r.actions}</td>
              <td className="mono" style={{ color: r.first > 60 ? C.neg : undefined }}>{r.first}m</td>
              <td className="mono">{r.turn}h</td>
              <td className="mono">{r.won}</td>
              <td className="mono">{Math.round((r.won / r.leads) * 100)}%</td>
              <td className="mono" style={{ fontWeight: 700 }}>{money(r.rev)}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  </Section>
);

export const LostReasons = () => (
  <Section title="Why leads were lost" sub={`${FUNNEL.lost} lost in period`} icon={XCircle} testid="lx-lost">
    <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
      {LOST_REASONS.map(([r, n]) => (
        <div key={r} data-testid={`lx-lost-${r.split(" ")[0].toLowerCase()}`}>
          <div style={{ display: "flex", justifyContent: "space-between", fontSize: 13 }}><span>{r}</span><span className="mono"><b>{n}</b> <span className="muted">· {Math.round((n / FUNNEL.lost) * 100)}%</span></span></div>
          <div style={{ height: 6, background: "#E6EEEF", borderRadius: 3, marginTop: 4 }}><div style={{ width: `${(n / FUNNEL.lost) * 100}%`, height: 6, background: C.teal, borderRadius: 3 }} /></div>
        </div>
      ))}
    </div>
  </Section>
);
